import { BrandLockup } from "../components/BrandLockup";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

export default function AcceptInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  useEffect(() => { document.title = "Accept staff invitation | Dutsen Kauna Foundation"; api.get(`/auth/invite/${token}`).then((r) => setInv(r.data)).catch((e) => setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message)); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setErr("Passwords do not match.");
    setErr("");
    try { await api.post("/auth/invite/accept", { token, password: pw }); setDone(true); setTimeout(() => nav("/admin/login"), 2500); }
    catch (e2) { setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message); }
  };

  return (
    <div className="min-h-screen bg-[#155e3f] flex items-center justify-center px-4" data-testid="accept-invite-page">
      <div className="max-w-md w-full">
        <div className="text-center mb-8"><BrandLockup tone="dark" size="lg" className="justify-center w-full mb-4" /><h1 className="font-serif text-3xl text-white font-bold">Staff invitation</h1></div>
        <div className="bg-[#155e3f] border border-white/10 rounded-2xl p-8 space-y-4 text-white">
          {done ? <div className="text-center" data-testid="invite-done"><ShieldCheck size={36} className="mx-auto text-[#d6aa43]" /><p className="mt-3">Account created. Redirecting to sign in — you will enrol multi-factor authentication on first login.</p></div>
            : inv ? (
              <form onSubmit={submit} className="space-y-4" data-testid="accept-invite-form">
                <p className="text-sm text-white">Welcome <strong className="text-white">{inv.name}</strong>. You are being set up as <strong className="text-[#d6aa43]">{inv.role_label}</strong> ({inv.email}).</p>
                <input type="password" required placeholder="Create password (12+ chars, upper, lower, number)" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full bg-[#155e3f] border border-white/15 rounded-md px-4 py-3 text-white" data-testid="invite-password" />
                <input type="password" required placeholder="Confirm password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full bg-[#155e3f] border border-white/15 rounded-md px-4 py-3 text-white" data-testid="invite-password2" />
                {err && <div className="text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-md px-3 py-2" data-testid="invite-error">{err}</div>}
                <button className="dk-btn-primary w-full justify-center" data-testid="invite-accept-submit">Create my staff account</button>
                <p className="text-[11px] text-white">By continuing you agree to use this account only for authorised Foundation work, never share it, and keep beneficiary information confidential.</p>
              </form>
            ) : <div className="text-sm text-red-300" data-testid="invite-error">{err || "Loading…"}</div>}
        </div>
      </div>
    </div>
  );
}
